import React, {Suspense} from 'react'
import AddTeamDialog from './AddTeamDialog'
import {Loader} from '../utils/relay/renderLoader'
import useQueryLoaderNow from '../hooks/useQueryLoaderNow'
import addTeamDialogQuery, {} from '../__generated__/AddTeamDialogQuery.graphql'






const AddTeamDialogRoot = (props) => {
  const {onClose, onAddTeam} = props

  const queryRef = useQueryLoaderNow(addTeamDialogQuery, {}, 'network-only')

  return (
    React.createElement(Suspense, { fallback: React.createElement(Loader, null ),}
      , queryRef && (
        React.createElement(AddTeamDialog, { onAddTeam: onAddTeam, isOpen: true, onClose: onClose, queryRef: queryRef,} )
      )
    )
  )
}

export default AddTeamDialogRoot
